import './Activity.scss'
import * as React from 'react'
import { Link, useCurrentRoute } from 'react-navi'
import { Cookie } from 'src/utils/cookie'
import { JWT } from 'src/utils/jwt'
import { WXShareConfig } from 'src/utils/config'
import { formatDate } from './helper'
import { defaultAppFn } from '../../utils/app'

import arrow_down from '../../images/arrow_down_circle.png'
import arrow_up from '../../images/arrow_up_circle.png'
import rank from '../../images/rank_grey.png'

const ActivityList: React.SFC = () => {
    const { data } = useCurrentRoute()
    const productIDs = Object.keys(data)

    // 微信分享设置
    const jwt = JWT.decode(Cookie.get())
    WXShareConfig(
        `${jwt ? jwt.user_name : ''}邀请您参加上海有色网投票活动`,
        '参加上海有色网投票活动，领取精彩奖励',
        window.location.href,
        'https://imgqn.smm.cn/production/hybrid/exkOj20190703111132.png'
    )

    defaultAppFn.Apply('app_nav', {
        show: true,
        back: true,
        title: '有色投票',
        share: false
    })

    return (
        <div className="ActivityListWrap">
            <div className="ActivityList">
                {
                    productIDs.map(id => {
                        const item = data[id]
                        return (
                            <ActivityCard
                                key={id}
                                id={item.id}
                                img={item.cover_img}
                                title={item.name}
                                info={item.description || '暂无详情'}
                                time={formatDate("yyyy-MM-dd hh:mm:ss", new Date(item.dead_line * 1000))}
                                volume={item.vote_num}
                                optionId={item.latest_activity ? item.latest_activity.id : 0}
                            />
                        )
                    })
                }
            </div>
        </div>
    )
}

interface IActivityCardProp {
    id: number
    img: string
    title: string
    info: string
    time: string
    volume: string
    optionId: string
}

class ActivityCard extends React.Component<IActivityCardProp, {}>{
    public state: {
        isCos: boolean
    }
    public cosDetail() {
        this.setState({
            isCos: !this.state.isCos
        })
    }
    public componentWillMount() {
        this.setState({
            isCos: true
        })
    }
    public render() {
        const { id, img, title, info, time, volume, optionId } = this.props
        const timeover = () => {
            return time < formatDate("yyyy-MM-dd hh:mm:ss", new Date())
        }

        return (
            <div className="ActivityCard">
                <Link href={`/group/${id}/detail/${optionId}`}>
                    <div className="ActivityCardImg">
                        <img src={img} alt="" />
                        <div className={["ActivityEnd", timeover() ? '' : 'hidden'].join(' ')}>
                            <p>- 已结束 -</p>
                        </div>
                    </div>
                </Link>
                <div className="Detail">
                    <div className="DetailTitle">
                        <Link href={`/group/${id}/detail/${optionId}`}>
                            <h2>{title}</h2>
                        </Link>
                        <img src={this.state.isCos ? arrow_down : arrow_up} alt="cos" onClick={() => { this.cosDetail() }} />
                    </div>
                    <div className={["DetailInfo", this.state.isCos ? 'hidden' : ''].join(' ')}>
                        <Link href={`/group/${id}/detail/${optionId}`}>
                            <p>
                                {info}
                            </p>
                        </Link>
                    </div>
                    <div className="DetailAddon">
                        <span>截止: </span>
                        <span> {time}</span>
                        <div className="DetailVolume">
                            <img src={rank} alt="" />
                            <span>{volume || 0}</span>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export {
    ActivityCard,
    ActivityList
}


// WEBPACK FOOTER //
// ./src/components/activities-list/Activity.tsx